import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { Button, ListItemText } from '@material-ui/core'
import { Field, Form } from 'react-final-form'
import Input from 'components/common/Form/Input'
import getValidator, { VALIDATOR_IS_NUMBER } from 'validation'
import { setCustomSensorLimits } from 'reducers/sensor/reducer'
import withPromise from 'helpers/withPromise'
import messages from './translate'

class CustomLimits extends Component {
  onSubmitCustomLimits = data => {
    const {
      intl: { formatMessage },
      sensorsData,
      activeSite,
      close,
      setCustomSensorLimits,
    } = this.props
    const result = []
    const summary = sensorsData.get('summary')

    if (summary !== undefined && summary.length > 0) {
      for (let i = 0; i < summary.length; i += 1) {
        const sensor = summary[i]

        for (const key in data) {
          if (
            data.hasOwnProperty(key) &&
            `name_${sensor.sensor_id}_${sensor.sensor_type_id}` === key
          ) {
            const value = data[key]

            result.push({
              sensor: sensor.sensor_id,
              sensor_type: sensor.sensor_type_id,
              max_value: value === '' || value === null ? null : Number(value),
            })
          }
        }
      }
    }

    close()

    return withPromise(setCustomSensorLimits, {
      data: {
        site: activeSite.id,
        data: result,
      },
      successMessage: formatMessage(messages.successMessage),
    }).then(errors => {
      if (errors) {
        return Promise.resolve(errors)
      }
    })
  }

  getDefaultLimits = () => {
    const summary = this.props.sensorsData.get('summary')
    const value = {}

    if (summary !== undefined && summary.length > 0) {
      for (let i = 0; i < summary.length; i += 1) {
        const entry = summary[i]

        for (const key in entry) {
          if (entry.hasOwnProperty(key)) {
            value[`name_${entry.sensor_id}_${entry.sensor_type_id}`] =
              entry.max_value_set === null ? '' : entry.max_value_set
          }
        }
      }
    }

    return value
  }

  render() {
    const {
      sensorsData,
      close,
      intl: { formatMessage },
    } = this.props
    const sensorList = sensorsData.get('summary')

    return (
      <div className="custom-limits">
        <Form
          onSubmit={this.onSubmitCustomLimits}
          initialValues={this.getDefaultLimits()}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <List className="limit-list" disablePadding>
                <ListItem key="first" className="item-head" disableGutters>
                  <ListItemText
                    primary={formatMessage(messages.parameter)}
                    secondary={formatMessage(messages.value)}
                  />
                </ListItem>
                {sensorList.map(item => (
                  <ListItem key={item.parameter} disableGutters>
                    <ListItemText primary={item.parameter} />
                    <Field
                      name={`name_${item.sensor_id}_${item.sensor_type_id}`}
                      type="text"
                      allowNull
                      InputProps={{ placeholder: '0.0' }}
                      component={Input}
                      className="form-control"
                      parse={value => value}
                      validate={getValidator([VALIDATOR_IS_NUMBER])}
                    />
                  </ListItem>
                ))}
              </List>
              <div className="button-group">
                <Button color="default" variant="contained" onClick={close}>
                  {formatMessage(messages.cancel)}
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleSubmit}>
                  {formatMessage(messages.save)}
                </Button>
              </div>
            </form>
          )}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    sensorsData: state.getIn(['sensor', 'sensorsData']),
    activeSite: state.getIn(['profile', 'profile', 'site']),
  }),
  {
    setCustomSensorLimits,
  },
)(injectIntl(CustomLimits))
